import React from 'react';

const ClockIcon = (props) => {

  const { size, color, className, onClick } = props;

  return (
        <div className={className} onClick={onClick}>
            <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M26 15C26 17.1756 25.3549 19.3023 24.1462 21.1113C22.9375 22.9202 21.2195 24.3301 19.2095 25.1627C17.1995 25.9952 14.9878 26.2131 12.854 25.7886C10.7202 25.3642 8.76021 24.3166 7.22183 22.7782C5.68345 21.2398 4.6358 19.2798 4.21137 17.146C3.78693 15.0122 4.00477 12.8005 4.83733 10.7905C5.66989 8.78049 7.07979 7.06253 8.88873 5.85383C10.6977 4.64514 12.8244 4 15 4C17.9174 4 20.7153 5.15893 22.7782 7.22183C24.8411 9.28473 26 12.0826 26 15Z" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M14.353 9.5V15L20.353 20.5" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </div>
    );
}

export default ClockIcon;